const styles = () => ({
  root: {
    color: '#ffff',
    fontSize: 8,
    borderRadius: 7,
    padding: '2px 5px 1px',
    display: 'flex',
    alignItems: 'center',

    '&& svg': {
      marginRight: 4,
    },
  },

  blue: {
    backgroundColor: '#148cfc',
  },

  orange: {
    backgroundColor: '#fdb61c',
  },

  green: {
    backgroundColor: '#31d48b',
  },
});

export default styles;
